import { createContext, useContext, useState } from "react";

export const NAVIGATION_PRIORITIES = {
    PARENT_FORM: 1,
    NESTED_FORM: 3,
    METADATA_FORM: 2,
    // Same tier as the metadata form: a per-tab draft that lives above the
    // parent record form. The comments tab and the metadata tab are mutually
    // exclusive (only one tab's content is mounted at a time), so sharing the
    // numeric priority is safe.
    COMMENT_FORM: 2,
    // Highest tier: an action-button request is in flight. This is a short-lived,
    // app-global guard (see ActionInFlightGuard) that must win over any form's
    // unsaved-changes prompt so the user is warned about losing the in-flight
    // request itself, not just the form edits.
    ACTION_IN_FLIGHT: 4,
    DEFAULT: 0,
} as const;

interface NavigationPromptContextType {
    priority: number;
    setPriority: (priority: number) => void;
}

const NavigationPromptContext = createContext<NavigationPromptContextType>({
    priority: 0,
    setPriority: () => {},
});

export const NavigationPromptProvider = ({ children }: { children: React.ReactNode }) => {
    const [priority, setPriority] = useState(0);

    return (
        <NavigationPromptContext.Provider value={{ priority, setPriority }}>
            {children}
        </NavigationPromptContext.Provider>
    );
};

export const useNavigationPrompt = () => useContext(NavigationPromptContext);
